//delay na scroll!!!!
class CollectionLoadMore extends HTMLElement {
	constructor() {
		super()
		window.currentPage = 1
		window.allPagesLoaded = false
		this.loader = this.querySelector(".loader")
		window.addEventListener("scroll", () => {
			if (
				!window.loading &&
				window.innerHeight + window.scrollY >=
					document.body.offsetHeight
			) {
				this.loadNextPage()
			}
		})

		let itemsFetched = document.querySelector(".js-product-count")
		let totalProducts = document.querySelector(".js-total-product-count")

		if (itemsFetched && totalProducts) {
			itemsFetched = parseInt(itemsFetched.innerHTML)
			totalProducts = parseInt(totalProducts.innerHTML)

			if (itemsFetched >= totalProducts) {
				window.allPagesLoaded = true
			}
		}
	}

	getQueryForBlogPagination(sectionId) {
		const params = new URLSearchParams(window.location.search)
		let query = ""

		for (let p of params) {
			if (p[0] !== "page") {
				if (query !== "") {
					query += "&"
				}

				query += `${p[0]}=${p[1]}`
			}
		}

		const partQuery = `?section_id=${sectionId}&page=${window.currentPage}${
			query !== "" ? "&" : ""
		}`

		return partQuery + query
	}

	loadNextPage() {
		if (window.allPagesLoaded) {
			return
		}

		this.loader.style.display = "block"
		const sectionId = document.getElementById("product-grid").dataset.id
		window.currentPage++
		const query = this.getQueryForBlogPagination(sectionId)
		fetch(query)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser()
					.parseFromString(responseText, "text/html")
					.querySelector(`[id*="${sectionId}"]`).innerHTML
				this.renderPostGrid(html)

				const searchParams = new URLSearchParams(query)
				searchParams.delete("section_id")
				//history.pushState(null, null, "?" + searchParams.toString())
			})
	}

	renderPostGrid(html) {
		const content = new DOMParser().parseFromString(html, "text/html")
		const postGrid = content.getElementById("product-grid")
		const innerHTML = postGrid.innerHTML

		let itemsFetched = content.querySelector(".js-product-count")
		let totalProducts = content.querySelector(".js-total-product-count")

		document.querySelector(".js-product-count").innerHTML =
			itemsFetched >= totalProducts ? totalProducts : itemsFetched
		if (postGrid.querySelector(".template-main-collection__item")) {
			document
				.getElementById("product-grid")
				.insertAdjacentHTML("beforeend", innerHTML)
		}
		if (itemsFetched && totalProducts) {
			itemsFetched = parseInt(itemsFetched.innerHTML)
			totalProducts = parseInt(totalProducts.innerHTML)
			if (itemsFetched >= totalProducts) {
				window.allPagesLoaded = true
				this.loader.style.display = "none"
			}
		}
	}
}

customElements.define("collection-load-more", CollectionLoadMore)
